import { InjectionToken } from "@angular/core";
import { ITermsAndConditionsService } from "./terms-and-conditions-service.interface";

export const TERMS_AND_CONDITIONS_SERVICE = new InjectionToken<ITermsAndConditionsService>(
  'TERMS_AND_CONDITIONS_SERVICE'
);
